import * as React from 'react';

export interface ContentPlayerActionsValue {
    /** Triggers the engine-core submit flow (grading + callbacks). */
    requestSubmit: () => void;
}

export const ContentPlayerActionsContext = React.createContext<ContentPlayerActionsValue | null>(null);

/** Returns ContentPlayer submit actions when rendered inside ContentPlayer; null otherwise. */
export function useContentPlayerActions(): ContentPlayerActionsValue | null {
    return React.useContext(ContentPlayerActionsContext);
}
